<div
  class="backdrop"
  [style.--backdrop-opacity]="backdropOpacity"
  (click)="onBackdropClick()"
></div>

<div class="modal" [style.--max-width]="maxWidth" [style.--margin-top]="marginTop">
  <ng-content></ng-content>
</div>
